import { useEffect, useState } from "react";
import GameBoard from "./GameBoard";
import QuestionPanel from "./QuestionPanel";
import ResultPanel from "./ResultPanel";
import { generateShape, analyzeResult } from "./gameLogic";

export default function FocusGame() {
  const [phase, setPhase] = useState("start");
  const [duration, setDuration] = useState(30000);
  const [current, setCurrent] = useState(null);
  const [session, setSession] = useState([]);
  const [result, setResult] = useState(null);

  const speed = 3000; // slow = better focus

  useEffect(() => {
    if (phase !== "focus") return;

    const temp = [];

    const interval = setInterval(() => {
      const s = generateShape();
      temp.push(s);
      setCurrent(s);
    }, speed);

    const timer = setTimeout(() => {
      clearInterval(interval);
      setSession(temp);
      setPhase("recall");
    }, duration);

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, [phase]);

  return (
    <>
      {phase === "start" && (
        <div className="h-screen flex flex-col justify-center items-center gap-6">

          <h1 className="text-3xl font-bold">Focus Trainer</h1>

          <select
            className="border p-2"
            onChange={(e) => setDuration(Number(e.target.value))}
          >
            <option value={30000}>30 Seconds</option>
            <option value={60000}>60 Seconds</option>
            <option value={120000}>2 Minutes</option>
          </select>

          <button
            onClick={() => setPhase("focus")}
            className="bg-blue-600 text-white px-6 py-2 rounded"
          >
            Start Focus
          </button>
        </div>
      )}

      {phase === "focus" && <GameBoard shape={current} />}

      {phase === "recall" && (
  <QuestionPanel
    onSubmit={(userCounts) => {
      console.log("User Counts:", userCounts);

      const r = analyzeResult(session, userCounts);

      console.log("Result:", r);

      setResult(r);
      setPhase("result");
    }}
  />
)}


      {phase === "result" && (
        <ResultPanel
          result={result}
          onRestart={() => window.location.reload()}
        />
      )}
    </>
  );
}
